import { render, staticRenderFns } from "./CourseVideosModalComponent.vue?vue&type=template&id=8fdaa622&scoped=true&lang=pug&"
import script from "./CourseVideosModalComponent.vue?vue&type=script&lang=js&"
export * from "./CourseVideosModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideosModalComponent.vue?vue&type=style&index=0&id=8fdaa622&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdaa622",
  null
  
)

export default component.exports